"use strict";
if (!global.Buffer) {
    global.Buffer = require('buffer').Buffer;
}
